<template>
    <div>
        <div class="warp">
            
            <div class="footer">成都经开龙安信息科技服务有限公司</div>
            <div class="formBox">
                <div class="title">
                    <img src="../../assets/login/homeLogin.png" alt="">
                </div>
                <div class="forms">
                    <div class="loginTitle">后台管理系统</div>
                    <div class="forms_label">账号</div>
                    <div class="child">
                        <el-input v-model="sendInfo.userName" placeholder="请输入用户账号/手机号" maxlength="20"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.userName']">错误提示：{{errors['sendInfo.userName']}}</div>
                    <div class="forms_label">登录密码</div>
                    <div class="child">
                        <el-input type="password" v-model="sendInfo.password" placeholder="请输入密码" maxlength="20"></el-input>
                    </div>
                    <div class="error" v-if="errors['sendInfo.password']">错误提示：{{errors['sendInfo.password']}}</div>
                    <div class="forms_label">验证码</div>
                    <div class="childImgCode">
                        <el-input v-model="sendInfo.code" placeholder="请输入验证码" @click="changeImg"></el-input>
                        <img :src="codeImg" @click="changeImg">
                    </div>
                    <div class="error" v-if="errors['sendInfo.code']">错误提示：{{errors['sendInfo.code']}}</div>
                    <div class="singleButton"><el-button type="primary" @click="submit">登录</el-button></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
export default {
    data(){
        return{
            sendInfo:{
                userName:'',//账号
                password:'',//密码
                code:'',//图形验证码
                verifyKey:'',//验证码key
            },
            codeImg:'',//图形验证码地址
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfo.userName':{
            test:/^[\w]{4,20}$/,
            message:'输入账号'
        },
        'sendInfo.password':'password',
        'sendInfo.code':'code'
    },
	created() {
		this.keyupSubmit()
	},
    methods:{
		keyupSubmit(){
		  document.onkeydown=e=>{
		    let _key=window.event.keyCode;
		    if(_key===13){
		      this.submit()
		    }
		  }
		},
        //切换验证图片
        changeImg:function(){
            this.$axiosz.get('rpc/verify/code').then((r)=>{
                if(r.code==200){
                    this.codeImg=r.data.imageUrl;
                    this.sendInfo.verifyKey=r.data.verifyKey;
                }else{
                    this.$alert(r.msg, {
                        confirmButtonText: '确定',
                        callback: action => {
                            // this.changeCode();
                        }
                    })
                }
            })
        },
        // 登录
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axios.post('backstage/login',qs.stringify(this.sendInfo),{headers:{
                     'Content-Type': 'application/x-www-form-urlencoded'
                }}).then((r)=>{
                    if(r.code==200){
                        this.$store.commit({
                            type:'user/loginIn',
                            username:r.data.userInfo.username,
                            token:r.data.access_token,
							userTypeName:r.data.userInfo.userTypeName,
							sysRoleVoList:r.data.userInfo.sysRoleVoList
                        })
                        window.localStorage.setItem('userInfo',JSON.stringify(r.data.userInfo))
                        // 操作权限
                        let authorities=[];
                        let data=r.data.userInfo.authorities;
                        for(let i in data){
                            authorities.push(data[i].authority)
                        }
                        this.$store.commit({
                            type:'user/authorities',
                            authorities:authorities
                        })
                        window.localStorage.setItem('authorities',JSON.stringify(authorities))
                        this.$router.push('/');
                    }else{
						this.$message.error(r.msg);
                        this.changeImg();
                    }
                })
            }
        }
    },
    mounted(){
        this.changeImg();
    },
    destroyed(){
        document.onkeydown=e=>{
            
        }
    }
}
</script>

<style lang="scss" scoped>
.footer{
    position: absolute;
    bottom: 30px;
    right: 30px;
    font-size:12px;
    font-family:Microsoft YaHei;
    font-weight:400;
    line-height:20px;
    color:rgba(255,255,255,1);
    height: 20px;
}
.warp{
    position: absolute;
    top: 0;
    left: 0;
    bottom:0;
    right: 0;
    background: url(../../assets/login/login_bg.png)no-repeat center;
    background-size: 100% 100%;
    min-width: 400px;
    min-height: 400px;
    .title{
        display: flex;
        flex-direction: column;
        margin:0 auto 64px;
        //height: 200px;
        &>img{
            width: 330px;
        }
        div{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: 53px;
            span{
                font-size:42px;
                font-family:Microsoft YaHei;
                font-weight:bold;
                line-height:55px;
                color:rgba(255,255,255,1);
                letter-spacing: 5px;
            }
            img{
                width: 33px;
                margin-left: 23px;
            }
        }
    }
    .formBox{
        position: absolute;
        top: 50%;
        right: calc(50% - 400px/2);
        transform: translateY(-50%);
        width:400px;
        // height:400px;
        .forms{
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 8px rgba(0,0,0,0.08);
            border-radius:3px;
            box-sizing: border-box;
            padding: 36px 41px 80px;
            .loginTitle{
                font-size:30px;
                font-weight:bold;
                color:rgba(19,50,113,1);
                margin-bottom:49px;
            }
            &_label{
              width:100%;
              margin-top:10px;
              color:#393939;
              font-size: 16px;
              margin-top:30px;
              &:first-child{
                margin-top:0;
              }
            }
            &::v-deep{
              .el-input{
                .el-input__inner{
                  border-radius: 0;
                  border-width:0 0 1px 0;
                  border-color: #D9D9D9;
                  padding:0;

                }
              }
              input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {
                -webkit-text-fill-color: #ededed !important;
                -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;
                background-color:transparent;
                background-image: none;
                transition: background-color 50000s ease-in-out 0s; //背景色透明  生效时长  过渡效果  启用时延迟的时间
            }
            input {
                background-color:transparent;
            }
            }
        }
    }
}
</style>
